// ----------------------------------------------------------------------

const account = {
  displayName: 'Smart Contract Scanner User',
  email: '',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg',
};

export default account;
